module.exports = __webpack_public_path__ + "dancingscript-regular-webfont.c58ce3f3a956e088b438.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/dancing/dancingscript-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/dancing/dancingscript-regular-webfont.woff
// module chunks = 1